import { render } from "./StepTwo.vue?vue&type=template&id=190b3449&ts=true"
import script from "./StepTwo.vue?vue&type=script&lang=ts"
export * from "./StepTwo.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/martjan/repositories/q-42/virtueel-indisch-monument/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__